<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
body {
	font-family: cambria;
}
.ulred {
	color: #b71511;
	color: rgb(183,21,17);
}
.lmenu td {
	color: #9e9e9e;
}
.redlinks a {
	color: #9e9e9e;
}
.redlinks a:hover {
	color: #b71511;
}
.text-secondary {
	color: #9e9e9e !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue